import { render, staticRenderFns } from "./page-create-affirmation.vue?vue&type=template&id=5b3f3d60"
import script from "./page-create-affirmation.vue?vue&type=script&lang=ts"
export * from "./page-create-affirmation.vue?vue&type=script&lang=ts"
import style0 from "./page-create-affirmation.vue?vue&type=style&index=0&id=5b3f3d60&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports